// extracted by mini-css-extract-plugin
export default {"headText":"PageMainText_headText__AE9Fu"};